import React from 'react';
import { AiSection } from './AiBox';
import { SourceChips } from './SourceChips';

// Items shape: { title?, detail?, text?, quote?, moment_ids }
export const AiItems = ({ label, items = [], moments, onOpen }) => {
  if (!items.length) return null;
  return (
    <AiSection label={label}>
      <div className="space-y-3">
        {items.map((it, i) => (
          <div key={i}>
            {it.title && <p className="font-semibold text-slate-900 break-words">{it.title}</p>}
            {it.detail && <p className="break-words">{it.detail}</p>}
            {it.text && <p className="break-words">{it.text}</p>}
            {it.quote && <p className="text-xs italic text-slate-500 break-words">You wrote: “{it.quote}”</p>}
            <SourceChips ids={it.moment_ids} moments={moments} onOpen={onOpen} />
          </div>
        ))}
      </div>
    </AiSection>
  );
};

export const itemsToText = (label, items = []) =>
  items.length
    ? `${label}\n${items.map((it) => `- ${[it.title, it.detail, it.text].filter(Boolean).join(': ')}`).join('\n')}\n\n`
    : '';